export const emailValidation = (email: string): boolean => {
    const emailRegex =
        /^([\w!#$%&'*+/=?^`{|}~]+\.)*[\w!#$%&'*+/=?^`{|}~]+@(([a-z0-9][a-z0-9\-]{0,62}[a-z0-9]\.)+[a-z]{2,6}|\d{1,3}(\.\d{1,3}){3}(:\d{1,5})?)$/i;
    return emailRegex.test(email);
};
